import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';

import ContactForm from '../../pages/ContactUs/ContactForm';

class ContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: true });
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, community, metro, widget, agent } = this.props;
    const phone = _.get(community, 'osc_phone') ||
      _.get(metro, 'osc_phone') ||
      _.get(widget, 'header[0].phone');
    return (
      <div>
        <a href="" onClick={this.openModal}>
          {children}
        </a>
        <Modal
          className="modal-wrapper"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Example Modal"
          overlayClassName="modal-overlay"
        >
          <a href className="modal-close" onClick={this.closeModal}>&times;</a>
          <div className="contact-modal-header">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <img src={_.get(agent, 'logo.contentUrl')} alt="Online Sales Counselors" />
                </div>
                <div className="col-md-8">
                  <h2>{_.get(widget, 'header[0].title')}</h2>
                  <p dangerouslySetInnerHTML={SanitizeHtml(_.get(widget, 'header[0].message'))} className="text-white" />
                  <h3>
                    Call {' '}
                    <a href={`tel:${phone.replace(/[^0-9]/g, '')}`} className="text-white">
                      {phone}
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-modal-body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <ContactForm noRedirect />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ContactModal.propTypes = {
  widget: PropTypes.object,
  agent: PropTypes.object.isRequired,
  community: PropTypes.object,
  metro: PropTypes.object,
  children: PropTypes.node,
};

ContactModal.defaultProps = {
  widget: undefined,
  community: undefined,
  metro: undefined,
  children: undefined,
};

export default withData(
  {
    widget: 'contact_banners',
    community: true,
    metro: true,
    agent: true,
  },
  {
    required: {
      widget: true,
      agent: true,
    },
  },
)(ContactModal);



// WEBPACK FOOTER //
// ./src/components/ContactModal/index.js